import { Link } from "react-router-dom";

export function TableLink({ href, children, openInNewTab = false }) {
  const newTabProps = openInNewTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  // The colours carry `!` because Semantic UI's unlayered `a` rules beat
  // Tailwind's layered utilities.
  return (
    <Link
      to={href}
      className="tw:font-bold tw:text-(--color-text-primary)! tw:no-underline tw:hover:text-(--color-blue)!"
      {...newTabProps}
    >
      {children}
    </Link>
  );
}
